import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './nigeria-stockbroking-price-list.component.scss';
import axios from 'axios';
import * as _ from 'lodash';
var NigeriaStockbrokingPriceList = /** @class */ (function (_super) {
    tslib_1.__extends(NigeriaStockbrokingPriceList, _super);
    function NigeriaStockbrokingPriceList(element) {
        return _super.call(this, element) || this;
    }
    NigeriaStockbrokingPriceList.prototype.init = function () {
        this.containerResults = this.element.querySelector('#results');
        this.containerDate = this.element.querySelector('.nigeria-stockbroking-price-list__date');
        this.containerShowing = Array.from(this.element.querySelectorAll('.nigeria-stockbroking-price-list__showing'));
        this.formInputSymbol = this.element.querySelector('.js-form-search-bar');
        this.filterTh = Array.from(this.element.querySelectorAll('th'));
        this.json = [];
        this.total = 0;
        this.getResults();
    };
    NigeriaStockbrokingPriceList.prototype.bindEvents = function () {
        var _this = this;
        this.formInputSymbol.addEventListener('keyup', function (e) {
            var element = undefined;
            element = e.target;
            _this.filterSymbol = element.value;
            _this.generateLayout(_this.json, _this.filterSymbol, _this.containerResults, _this.filterSortName, _this.filterSortOrder, _this.containerShowing, _this.total);
        });
        this.filterTh.map(function (th) { return th.addEventListener('click', function (e) {
            var element = undefined;
            element = e.target;
            _this.filterSortName = element.getAttribute('data-name');
            _this.removeClassFromTh();
            if (_this.filterSortOrder === 'asc') {
                _this.filterSortOrder = 'desc';
                element.classList.remove('asc');
                element.classList.add('desc');
            }
            else {
                _this.filterSortOrder = 'asc';
                element.classList.remove('desc');
                element.classList.add('asc');
            }
            _this.generateLayout(_this.json, _this.filterSymbol, _this.containerResults, _this.filterSortName, _this.filterSortOrder, _this.containerShowing, _this.total);
        }); });
    };
    NigeriaStockbrokingPriceList.prototype.getResults = function () {
        var _this = this;
        // attributes
        var filterSymbol = this.filterSymbol;
        var generateLayout = this.generateLayout;
        var containerResults = this.containerResults;
        var containerDate = this.containerDate;
        var containerShowing = this.containerShowing;
        var postData = '';
        // variables
        var url = "https://feeds.standardbank.com/Market-Data-Files/NSB/Rates/allNGAStock.json";
        // service
        axios.get(url).then(function (response) {
            var json = response.data;
            var rows = json.DataTable.Rows;
            _this.json = rows;
            var countResults = 0;
            rows.map(function (item) {
                if (item[20] === 'EQTY' || item[20] === 'PREMIUM') {
                    countResults++;
                }
            });
            _this.total = countResults;
            var todaysDay = new Date(_this.json[0][0]);
            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var valDate = monthNames[todaysDay.getMonth()] + " " + todaysDay.getDate() + ", " + todaysDay.getFullYear();
            containerDate.innerHTML = valDate;
            generateLayout(rows, filterSymbol, containerResults, '', '', containerShowing, _this.total);
        }).catch(function (error) {
            console.log(error);
        });
    };
    NigeriaStockbrokingPriceList.prototype.generateLayout = function (array, filterSymbol, container, sortName, sortOrder, containerShowing, total) {
        if (array === void 0) { array = []; }
        if (filterSymbol === void 0) { filterSymbol = ""; }
        if (container === void 0) { container = undefined; }
        if (sortName === void 0) { sortName = ''; }
        if (sortOrder === void 0) { sortOrder = "asc"; }
        if (containerShowing === void 0) { containerShowing = undefined; }
        if (total === void 0) { total = 0; }
        var output = "";
        var newArray = [];
        var showing = 0;
        var filterSymbolLowerCase = filterSymbol.toLowerCase();
        array.map(function (item) {
            if (item[20] === 'EQTY' || item[20] === 'PREMIUM') {
                var Attributesymbol = item[1];
                var Attributesecurity = item[2];
                var Attributeref = item[21];
                var Attributeopen = parseFloat(item[5]);
                var Attributehigh = parseFloat(item[6]);
                var Attributelow = parseFloat(item[7]);
                var Attributeclose = parseFloat(item[9]);
                var Attributechange = parseFloat(item[11]);
                var Attributevolume = parseFloat(item[12]);
                var Attributevalue = parseFloat(item[13]);
                var Attributename = item[14];
                var object = {
                    'symbol': Attributesymbol,
                    'security': Attributesecurity,
                    'ref': Attributeref,
                    'open': Attributeopen,
                    'high': Attributehigh,
                    'low': Attributelow,
                    'close': Attributeclose,
                    'change': Attributechange,
                    'volume': Attributevolume,
                    'value': Attributevalue,
                    'securityname': Attributename,
                };
                newArray.push(object);
            }
        });
        var newOrderedArray = newArray;
        if (sortName) {
            newOrderedArray = _.orderBy(newArray, [sortName], [sortOrder]);
        }
        newOrderedArray.map(function (item) {
            var Attributesymbol = item.symbol;
            var Attributesecurity = item.security;
            var Attributeref = item.ref;
            var Attributeopen = item.open;
            var Attributehigh = item.high;
            var Attributelow = item.low;
            var Attributeclose = item.close;
            var Attributechange = item.change;
            var Attributevolume = item.volume;
            var Attributevalue = item.value;
            var Attributename = item.securityname;
            var AttributesymbolLowerCase = Attributesymbol.toLowerCase();
            if (AttributesymbolLowerCase.includes(filterSymbolLowerCase)) {
                output += "<tr colspan=\"9\">\n\t\t\t\t\t<td>" + Attributesymbol + "</td>\n\t\t\t\t\t<td>" + Attributesecurity + "</td>\n\t\t\t\t\t<td>" + Attributeopen + "</td>\n\t\t\t\t\t<td>" + Attributehigh + "</td>\n\t\t\t\t\t<td>" + Attributelow + "</td>\n\t\t\t\t\t<td>" + Attributeclose + "</td>\n\t\t\t\t\t<td>" + Attributechange + "</td>\n\t\t\t\t\t<td>" + Attributevolume + "</td>\n\t\t\t\t\t<td>" + Attributevalue + "</td>\n\t\t\t\t</tr>";
                showing = showing + 1;
            }
        });
        console.log(showing);
        container.innerHTML = output;
        containerShowing.map(function (containerShow) {
            containerShow.innerHTML = "Showing " + showing + " of " + total + " entries";
        });
    };
    NigeriaStockbrokingPriceList.prototype.removeClassFromTh = function () {
        var theads = Array.from(this.element.querySelectorAll('th'));
        theads.map(function (th) {
            th.classList.remove('asc');
            th.classList.remove('desc');
        });
    };
    NigeriaStockbrokingPriceList.prototype.empty = function (value) {
        if (value === void 0) { value = ""; }
        var response = "-";
        if (value !== '' || value !== 'Nan') {
            response = value;
        }
        return response;
    };
    return NigeriaStockbrokingPriceList;
}(Base));
export { NigeriaStockbrokingPriceList };



//////////////////
// WEBPACK FOOTER
// ./components-nigeria/nigeria-stockbroking-price-list/nigeria-stockbroking-price-list.component.ts
// module id = 625
// module chunks = 0